var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#DC3545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 16.0938C15.2812 16.0625 15.0938 16 15 16C14.4375 16 14 16.4688 14 17C14 17.5625 14.4375 18 15 18C15.5312 18 15.9688 17.5625 15.9688 17C15.9688 16.9062 15.9375 16.7188 15.9062 16.625C15.8125 16.4062 15.5938 16.1875 15.375 16.0938ZM15.6875 11H14.2812C14 11.0312 13.7812 11.25 13.7812 11.5312V11.5625L14.1875 14.5625C14.2188 14.8125 14.4375 15 14.6875 15H15.2812C15.5312 15 15.75 14.8125 15.7812 14.5625L16.1875 11.5625C16.1875 11.5625 16.1875 11.5312 16.1875 11.5C16.1875 11.25 15.9688 11.0312 15.6875 11ZM15 23C16.0938 23 17 22.125 17 21H13C13 22.125 13.875 23 15 23ZM21.7188 18.3438C21.125 17.6875 19.9688 16.7188 19.9688 13.5C19.9688 11.0938 18.2812 9.15625 15.9688 8.65625V8C15.9688 7.4375 15.5312 7 14.9688 7C14.4375 7 13.9688 7.4375 13.9688 8C13.9688 8 13.9688 8 14 8V8.65625C11.6875 9.15625 10 11.0938 10 13.5C10 16.7188 8.84375 17.6875 8.25 18.3438C8.09375 18.5 8 18.7812 8 19C8 19.5312 8.40625 20 9 20H20.9688C21.5938 20 21.9688 19.5312 22 19C22 18.7812 21.875 18.5 21.7188 18.3438ZM10.0938 18.5C10.75 17.625 11.4688 16.1875 11.5 13.5312C11.5 13.5312 11.5 13.5312 11.5 13.5C11.5 11.5938 13.0625 10 15 10C16.9062 10 18.5 11.5938 18.5 13.5C18.5 13.5312 18.4688 13.5312 18.4688 13.5312C18.5 16.1875 19.2188 17.6562 19.875 18.5H10.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppError);
export default __webpack_public_path__ + "static/media/app_error.4bef3914.svg";
export { ForwardRef as ReactComponent };